import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledThemeCard = styled.div`
  position: relative;

  .theme {
    position: relative;
    display: flex;
    width: 100%;
    background: ${Colors.background};
    box-shadow: 0 1px ${pxToVw(4)} rgba(21, 34, 50, 0.2);
    border-radius: ${pxToVw(5)};
    padding: ${pxToVw(5)};
    flex-direction: column;

    .theme-layout {
      position: relative;
      display: flex;
      .theme-image {
        position: relative;
        height: ${pxToVw(147)};
        width: ${pxToVw(147)};

        img {
          border-radius: ${pxToVw(6)} 0 0 ${pxToVw(6)};
        }

        .placeholder {
          width: 100%;
          height: 100%;
          background: ${Colors.lightGray};
        }
      }

      .theme-content {
        position: relative;
        flex: 1;
        padding: 5px 10px 0;
        display: flex;
        flex-direction: column;

        height: ${pxToVw(143)};
        overflow: hidden;

        .theme-name {
          font-weight: bold;
          font-size: calc(var(--font-size-h3) - 2px);
          color: ${Colors.activityTypeColors.themes};
          margin-bottom: 3px;
        }
        .theme-subname {
          font-weight: bold;
          color: ${Colors.text};
          margin: 0px;
        }

        .theme-description {
          flex: 1;
          color: ${Colors.text};
          margin-bottom: 5px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .theme-favourite {
        position: absolute;
        right: 5px;
        top: 4px;
        .favourite-icon {
          color: ${Colors.primary};
          transition: color 0.2s;

          &.active,
          &:hover {
            color: ${Colors.purple};
          }
          span {
            margin-top: -8px;
            margin-right: -5px;
            font-size: 20px;
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}) {
    .theme {
      box-shadow: 0 1px ${pxToVw(8)} rgba(21, 34, 50, 0.2);
      border-radius: ${pxToVw(8)};
      padding: 4px;

      .theme-layout {
        .theme-image {
          height: 95px;
          width: 95px;

          img {
            border-radius: ${pxToVw(8)} 0 0 ${pxToVw(8)};
          }
        }

        .theme-content {
          gap: 0;
          height: 95px;

          .theme-subname {
            margin: 0px;
          }
        }

        .theme-favourite .favourite-icon {
          margin-left: 5px;
        }
      }
    }
  }
`;
